import { Component } from '@angular/core';

@Component({
  selector: 'global-header-skeleton',
  templateUrl: './global-header-skeleton.component.html',
  standalone: false,
})
export class GlobalHeaderSkeletonComponent {}